/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'
import axios from '@/axios.js'
import con from "@/firebase/firebaseInit.ts";
import AddToCalendar from 'vue-add-to-calendar'
import ls from "@/common/localStorage"

Vue.use(AddToCalendar);
//var cn = 'OA_UAT_C1591205467009E1591206650065';
var cn = ls.getSessionEventCollectionName();
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');

var FETCHCHECKINROLEAPIURL = con.checkinRoleFetchAPi;
var ADDCHCHECKINROLEAPIURL = con.checkinRoleAddAPi;
var FETCHCHECKINDESIGNATIONAPIURL = con.designationFetchAPi;
var SAVECHCHECKINDESIGNATIONAPIURL = con.designationSaveAPi;

var storageRef = con.storageRef;

export default {
    fetchGeoCheckinRoles({ commit }) {
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                }
            }
            let headers = {
                "content-type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }

            axios.post(FETCHCHECKINROLEAPIURL, requestData, { headers: headers }).then((response) => {
                if (response.status == 200) {
                    if (response.data.status == 0) {
                        markers.push(response.data.results);
                    }
                }
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching page engagement data==:', error)
            })

        })
    },
    addRole(context, field) {
        return new Promise((resolve, reject) => {
            console.log("field===5=", field);
            var roleImgUrl = "";
            if (field.data.File != null || field.data.File != undefined) {
                const file = field.data.File
                let metadata = {
                    'contentType': file.type
                }
                debugger;

                storageRef.child(cn + '/GeoCheckinRole/Image/' + (new Date().getTime()) + "_" + file.name).putString(field.data.ImageUrl, 'data_url').then(function (snapshot) {

                    snapshot.ref.getDownloadURL().then(function (url) {
                        roleImgUrl = url.toString();

                        let docObj = {
                            Name: field.data.Name,
                            Color: field.data.Color,
                            ImageUrl: roleImgUrl,
                            AccessType: field.data.roleAccessType ? field.data.roleAccessType : "Employee",
                            IsPublished: field.data.IsPublished,
                        }
                        let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                        let headers = {
                            "Content-Type": "application/json",
                            'Authorization': `Bearer ${accessToken}`,
                        }
                        let requestData = {
                            "key": {
                                "instanceId": "OA_UAT",
                                "clientId": Session_Client_Id,
                                "eventId": Session_Event_Id
                            },
                            "data": docObj,
                        };
                        axios.post(ADDCHCHECKINROLEAPIURL, requestData, { headers: headers }).then(function (res) {
                            if (res.status == 200) {
                                if (res.data.status == 0) {
                                    resolve({ status: 200, message: 'Location Added Succesfully.' })
                                }
                            }
                        }).catch(function (error) {
                            console.log(error)
                            reject(error)
                        })

                    }).catch(function (error) {
                        //console.log('download url '+error)                
                    })
                }).catch(function (error) {
                    //console.log('imgae upload '+error)                
                })
            } else {
                let docObj = {
                    Name: field.data.Name,
                    Color: field.data.Color,
                    ImageUrl: "",
                    AccessType: field.data.roleAccessType ? field.data.roleAccessType : "Employee",
                    IsPublished: field.data.IsPublished,
                }
                let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                let headers = {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${accessToken}`,
                }
                let requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id
                    },
                    "data": docObj,
                };
                axios.post(ADDCHCHECKINROLEAPIURL, requestData, { headers: headers }).then(function (res) {
                    if (res.status == 200) {
                        if (res.data.status == 0) {
                            resolve({ status: 200, message: 'Role Added Succesfully.' })
                        }
                    }
                }).catch(function (error) {
                    console.log(error)
                    reject(error)
                })
            }

        })
    },
    updateRole(context, field) {
        return new Promise((resolve, reject) => {
            console.log("field====", field);
            var roleImgUrl = "";

            if (field.data.File != null || field.data.File != undefined) {
                const file = field.data.File
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(cn + '/GeoCheckinRole/Image/' + (new Date().getTime()) + "_" + file.name).putString(field.data.ImageUrl, 'data_url').then(function (snapshot) {

                    snapshot.ref.getDownloadURL().then(function (url) {
                        roleImgUrl = url.toString();

                        let docObj = {
                            Name: field.data.Name,
                            Color: field.data.Color,
                            ImageUrl: roleImgUrl,
                            AccessType: field.data.AccessType ? field.data.AccessType : "Employee",
                            IsPublished: field.data.IsPublished
                        }
                        let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                        let headers = {
                            "Content-Type": "application/json",
                            'Authorization': `Bearer ${accessToken}`,
                        }
                        let requestData = {
                            "key": {
                                "instanceId": "OA_UAT",
                                "clientId": Session_Client_Id,
                                "eventId": Session_Event_Id,
                                "roleId": field.id
                            },
                            "data": docObj,
                        };
                        axios.put(ADDCHCHECKINROLEAPIURL, requestData, { headers: headers }).then(function (res) {
                            if (res.status == 200) {
                                if (res.data.status == 0) {
                                    resolve({ status: 200, message: 'Location Added Succesfully.' })
                                }
                            }
                        }).catch(function (error) {
                            console.log(error)
                            reject(error)
                        })

                    }).catch(function (error) {
                        //console.log('download url '+error)                
                    })
                }).catch(function (error) {
                    //console.log('imgae upload '+error)                
                })
            } else {



                let docObj = {
                    Name: field.data.Name,
                    Color: field.data.Color,
                    ImageUrl: field.data.ImageUrl,
                    AccessType: field.data.AccessType ? field.data.AccessType : "Employee",
                    IsPublished: field.data.IsPublished
                }
                let accessToken = ls.getSessionValueByKey('Session_AccessToken');
                let headers = {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${accessToken}`,
                }
                let requestData = {
                    "key": {
                        "instanceId": "OA_UAT",
                        "clientId": Session_Client_Id,
                        "eventId": Session_Event_Id,
                        "roleId": field.id
                    },
                    "data": docObj,
                };
                axios.put(ADDCHCHECKINROLEAPIURL, requestData, { headers: headers }).then(function (res) {
                    if (res.status == 200) {
                        if (res.data.status == 0) {
                            resolve({ status: 200, message: 'Role Added Succesfully.' })
                        }
                    }
                }).catch(function (error) {
                    console.log(error)
                    reject(error)
                })
            }
        })
    },

    fetchDesignations({ commit }) {
        return new Promise((resolve, reject) => {
            // resolve({ status: 200, data: markers })
            var mObj = {};
            const markers = []
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                }
            }
            let headers = {
                "content-type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }

            axios.post(FETCHCHECKINDESIGNATIONAPIURL, requestData, { headers: headers }).then((response) => {
                if (response.status == 200) {
                    if (response.data.status == 0) {
                        markers.push(response.data.results);
                    }
                }
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching page engagement data==:', error)
            })

        });
    },

    addDesignation(context, field) {
        return new Promise((resolve, reject) => {
            console.log("field===5=", field);

            let docObj = {};
            if (field.data.DesignationId) {
                docObj = {
                    DesignationId: field.data.DesignationId,
                    Name: field.data.Name,
                };
            } else {
                docObj = {
                    Name: field.data.Name,
                    IsPublished: field.data.IsPublished,
                };
            }
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`,
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id
                },
                "data": docObj,
            };
            axios.post(SAVECHCHECKINDESIGNATIONAPIURL, requestData, { headers: headers }).then(function (res) {
                if (res.status == 200) {
                    if (res.data.status == 0) {
                        resolve({ status: 200, message: 'Designation Added Succesfully.' });
                    } else {
                        resolve(res.data);
                    }
                }
            }).catch(function (error) {
                console.log(error)
                reject(error)
            })
        })
    },
    updateDesignation(context, field) {
        return new Promise((resolve, reject) => {
            console.log("field====", field);
            var roleImgUrl = "";

            let docObj = {
                DesignationId: field.data.DesignationId,
                IsPublished: field.data.IsPublished
            }
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`,
            }
            let requestData = {
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                    // "roleId": field.id
                },
                "data": docObj,
            };
            axios.put(SAVECHCHECKINDESIGNATIONAPIURL, requestData, { headers: headers }).then(function (res) {
                if (res.status == 200) {
                    if (res.data.status == 0) {
                        resolve({ status: 200, message: 'Designation Added Succesfully.' })
                    }
                }
            }).catch(function (error) {
                console.log(error)
                reject(error)
            })

        })
    },
}